<template>
  <b-modal
      v-model="show"
      v-if="show"
      centered
      hide-footer
      :title="editing ? 'ویرایش اتریبیوشن' : 'افزودن اتریبیوشن جدبد'"
      :no-close-on-backdrop="true"
      size="md"
  >
    <b-row>
      <b-col md="6">
        <b-form-group
            label="عنوان ادتریس ترکر"
            label-for="AdtraceTrackerName"
        >
          <b-form-input
              id="AdtraceTrackerName"
              v-model="form.AdtraceTrackerName"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
            label="لینک ادتریس"
            label-for="AdtraceLink"
        >
          <b-form-input
              id="AdtraceLink"
              v-model="form.AdtraceLink"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
            label="عنوان متریکس ترکر"
            label-for="MetrixTrackerName"
        >
          <b-form-input
              id="MetrixTrackerName"
              v-model="form.MetrixTrackerName"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
            label="لینک متریکس"
            label-for="MetrixLink"
        >
          <b-form-input
              id="MetrixLink"
              v-model="form.MetrixLink"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>
      <b-col class="col-md-6">
        <b-form-group
            label="کمپین"
            label-for="Campaign"
            class="d-inline-block full-width"
        >
          <campaign-select v-model="form.AdsCampaignId" />
        </b-form-group>
      </b-col>
      <b-col class="col-md-6">
        <b-form-group
            label="کانال تبلیغاتی"
            label-for="Channel"
            class="d-inline-block full-width"
        >
          <v-select
              ref="Channel"
              v-model="form.AdsChannelId"
              dir="rtl"
              :reduce="x => x.Id"
              label="Title"
              input-id="Channel"
              :clearable="false"
              :options="channels"
              @open="getChannels"
          >
            <span
                slot="no-options"
                @click="$refs.Channel.open = false"
            >
              {{ $t('common.noOptions') }}
            </span>
            <template #spinner>
              <div class="demo-inline-spacing">
                <b-spinner
                    v-if="channelLoading"
                    class="m-0"
                    small
                    variant="secondary"
                />
              </div>
            </template>
          </v-select>
        </b-form-group>
      </b-col>
    </b-row>
    <div class="text-center mt-2">
      <b-overlay :show="loading" rounded spinner-small class="d-inline-block">
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            :disabled="loading"
            @click="submit"
        >
          ذخیره
        </b-button>
      </b-overlay>
      <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-secondary"
          @click="$emit('update:show', !show)"
      >
        انصراف
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import CampaignSelect from "@/tools/campaign.vue";
import ChannelSelect from "@/tools/channel.vue";
export default {
  name: "attributionForm",
  components: { CampaignSelect },
  props: {
    show: { type: Boolean, default: false },
    item: { type: Object, default: null },
    campaigns: { type: Array, default: [] },
    channels: { type: Array, default: [] }
  },
  data() {
    return {
      loading: false,
      campaignLoading: false,
      channelLoading: false,
      form: {
        AdtraceLink: '',
        AdtraceTrackerName: '',
        MetrixLink: '',
        MetrixTrackerName: '',
        AdsCampaignId: '',
        AdsChannelId: ''
      }
    }
  },
  computed: {
    editing() {
      return this.item && this.item.Id
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        if (!val) this.form = {
          AdtraceLink: '',
          AdtraceTrackerName: '',
          MetrixLink: '',
          MetrixTrackerName: '',
          AdsCampaignId: '',
          AdsChannelId: ''
        }
      }
    },
    item: {
      immediate: true,
      handler(val) {
        if (val) {
          // this.getCampaigns()
          this.getChannels()
          this.form = val
        }
      }
    }
  },
  methods: {
    submit() {
      this.loading = true
      let url = this.editing ? this.$api.attributions.update : this.$api.attributions.add
      this.$http.post(url, this.form).then(() => {
        this.loading = false
        this.$emit('update:show', !this.show)
        this.$emit('update')
      }).finally(() => {
        this.loading = false
      })
    },
    getCampaigns() {
      if (this.campaigns.length) return
      this.campaignLoading = true
      this.$http.get(this.$api.campaigns.getAll).then(response => {
        this.$emit('update:campaigns', response.data)
        this.campaignLoading = false
      }).catch(() => {
        this.campaignLoading = false
      })
    },
    getChannels() {
      if (this.channels.length) return
      this.channelLoading = true
      this.$http.get(this.$api.channels.getAll).then(response => {
        this.$emit('update:channels', response.data)
        this.channelLoading = false
      }).catch(() => {
        this.channelLoading = false
      })
    }
  }
}
</script>